import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PersonalDetailsService {

  constructor(public http:HttpClient) { }

  public getProvinceDistrictValue(provinceId): Observable<any>{
    return this.http.get(environment.BASE_URL_COMMON+"cmn/getDistrictByDomicileProvince/"+provinceId)
  }

  public getProvinceCitiesValue(provinceId): Observable<any>{
    return this.http.get(environment.BASE_URL_COMMON+"cmn/getCitiesByDomicileProvince/"+provinceId)
  }

  public postSaveUserProfile(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_PROFILE+'profile/savePersonalDetails', payload)
  }
}
